import React, { useState, useEffect } from "react";
import { Container, Grid, CreateProyectPopUp } from "./styled";
import { Cards } from "../../componentes";
import firebase from "../../../lib/fire";
import { Loader } from "../../../components";
import secureLocalStorage from "react-secure-storage";

const Grilla = (data) => {
  const [isActive, setShowPopUp] = useState("false");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [participantes, setParticipantes] = useState("");
  const [description, setDescription] = useState("");
  const [goals, setGoals] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [proyects, setProyects] = useState(null);
  const [playID, setPlayID] = useState(0);
  const [loader, setLoader] = useState(0);
  const [fileSize, setFileSize] = useState(0);
  const userLocal = secureLocalStorage.getItem("userLocal");
  const userId = secureLocalStorage.getItem("userId");

  const handleClickNewProyect = () => {
    setShowPopUp("true");
  };
  const handleClickExitProyect = () => {
    setShowPopUp("false");
  };
  const handleChangeName = (value) => {
    setName(value);
  };

  const handleChangeCategory = (value) => {
    setCategory(value);
  };
  const handleChangeParticipantes = (value) => {
    setParticipantes(value);
  };

  const handleDescripcion = (value) => {
    setDescription(value);
  };
  const handleChangeGoals = (value) => {
    setGoals(value);
  };

  //----------GET PROYECTS FROM DATABSE-----------
  useEffect(() => {
    if (data.user !== null) {
      setProyects(data.user);
      setIsLoading(false);
    }
  }, [data]);

  //function to save file
  function uploadFile() {
    // Create a root reference
    var storageRef = firebase.storage().ref();

    // Create a reference to 'mountains.jpg'
    var mountainsRef = storageRef.child(`${name}.mp4`);

    // Create a reference to 'images/mountains.jpg'
    var mountainImagesRef = storageRef.child("file.mp4");

    //get the input file.
    var file = document.getElementById("files").files[0];
    //uploade the input file.
    var uploadTask = storageRef.child(`${name}.mp4`).put(file, file);
    if (fileSize <= 2) {
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function (snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //setLoader(progress);
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
            default:
              break;
          }
        },
        function (error) {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;

            case "storage/canceled":
              // User canceled the upload
              break;

            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
            default:
              break;
          }
        },
        function () {
          // Upload completed successfully, now we can get the download URL
          if (proyects.plays != null) var PlayID = proyects.plays.length;
          else PlayID = 0;
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            if (fileSize > 0) {
              firebase
                .database()
                .ref(`/users/0/${userId}/plays/${PlayID}`)
                .set({
                  //actualiza la data.
                  name: name,
                  category: category,
                  participantes: participantes,
                  description: description,
                  goals: goals,
                  videoFile: downloadURL,
                });
            } else {
              firebase
                .database()
                .ref(`/users/0/${userId}/plays/${PlayID}`)
                .set({
                  //actualiza la data.
                  name: name,
                  category: category,
                  participantes: participantes,
                  description: description,
                  goals: goals,
                  videoFile: false,
                });
            }
            resetForm();
            window.location.replace(`/editions/${PlayID}`); //go to edicion page
          });
        }
      );
      var loaderDiv = (document.getElementById("Loader").style.display =
        "block");
    } else {
      var errorMessage = (document.getElementById("FileError").style.display =
        "block");
    }
  }
  const checkFileSize = () => {
    var file = document.getElementById("files").files[0];
    let fileSize = parseInt(file.size);
    let fileSizeMB = Math.round(fileSize * 0.000001);
    setFileSize(fileSizeMB);
  };

  //reseta los valores del state del formulario
  function resetForm() {
    setShowPopUp("false");
    setName("");
    setCategory("");
    setParticipantes("");
    setDescription("");
    setGoals("");
    setVideoUrl("");
  }

  //
  function handleNextClick() {
    // Upload completed successfully, now we can get the download URL
    var PlayID;
    if (proyects.plays != null && proyects.plays !== undefined)
      PlayID = proyects.plays.length;
    else PlayID = 0;
    firebase
      .database()
      .ref(`/users/0/${userId}/plays/${PlayID}`)
      .set({
        //actualiza la data.
        name: name,
        category: category,
        participantes: participantes,
        description: description,
        goals: goals,
        videoFile: "comming soon",
      })
      .then(() => {
        let userBKP = userLocal;
        if (userBKP.plays !== undefined && userBKP.plays !== null) {
          userBKP.plays[PlayID] = {
            name: name,
            category: category,
            participantes: participantes,
            description: description,
            goals: goals,
          };
        } else {
          userBKP.plays = [];
          userBKP.plays.push({
            name: name,
            category: category,
            participantes: participantes,
            description: description,
            goals: goals,
          });
        }
        secureLocalStorage.setItem("userLocal", userBKP);
        resetForm();
        window.location.replace(`/app/editions/${PlayID}`); //go to edicion page
      });
  }
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Container>
        <CreateProyectPopUp
          className={isActive === "true" ? "active" : "unactive"}
        >
          <div className="BlackBackground" />
          <div className="PopUpContent">
            <div id="Loader" className="Loader">
              <p>Cargando: {loader}%</p>
            </div>
            <div className="PopUpTitle">
              <h1>Nuevo ejercicio</h1>
            </div>
            <div className="PopUpContainer">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleNextClick();
                }}
              >
                <p>Nombre</p>
                <input
                  className="inputName"
                  onChange={(e) => handleChangeName(e.currentTarget.value)}
                />
                <p>Descripción</p>
                <input
                  className="inputDescription"
                  onInput={(e) => handleDescripcion(e.currentTarget.value)}
                />
                <p>Objetivos</p>
                <input
                  className="inputGoals"
                  onInput={(e) => handleChangeGoals(e.currentTarget.value)}
                />
                <div className="buttonSection">
                  <button
                    onClick={handleClickExitProyect}
                    type="reset"
                    value="Reset"
                  >
                    Atrás
                  </button>
                  <button>Siguiente</button>
                </div>
              </form>
            </div>
          </div>
        </CreateProyectPopUp>
        <div className="flex_center_space-between">
          <h1 className="titulo">Proyectos</h1>
          <button className="btn-primary ghost" onClick={handleClickNewProyect}>
            Crear proyecto
          </button>
        </div>
        <Grid
          plays={
            proyects?.plays !== undefined && proyects?.plays !== null
              ? true
              : false
          }
        >
          {proyects?.plays !== undefined &&
            proyects?.plays !== null &&
            Object.values(proyects?.plays)?.map((play, i) => (
              <Cards play={play} index={i} key={i} />
            ))}
          {!proyects.plays ? (
            <div className="star-messagge">
              <h2>Comienza a crear tus jugadas</h2>
            </div>
          ) : null}
        </Grid>
      </Container>
    </>
  );
};

export default Grilla;
